import { render, staticRenderFns } from "./YfPaginator.vue?vue&type=template&id=e034a524&"
import script from "./YfPaginator.vue?vue&type=script&lang=js&"
export * from "./YfPaginator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports